import React from 'react';
import { Navigate } from 'react-router-dom';

const NotFound = () => <Navigate to="/login" />

export default NotFound;
